







import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class BreadcrumbsLink extends Vue {
  @Prop() private link?: string;
  @Prop() private text!: string;
}
